{
  "version": 1,
  "asset_id": "ba857d27-1160-4870-bd44-201b048c7358",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/ba857d27-1160-4870-bd44-201b048c7358/clip-img_2160-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/ba857d27-1160-4870-bd44-201b048c7358/clip-img_2160-poster-sm.webp",
  "original_filename": "clip-img_2160-poster-sm.webp",
  "size": 9028,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:30Z"
}
